import React, { useState, useEffect, useRef } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { LAYERS } from '../../constants/index';

const { Z_INDEX_WRAPPER } = LAYERS;

const generateStyles = (showPopup, isPlaying, isIOS) => ({
  container: {
    position: 'relative',
    textAlign: 'right',
    ['@md']: {
      textAlign: 'center'
    },
    ['@xs-only']: {
      display: isIOS ? 'none' : 'block'
    }
  },
  innerContainer: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    cursor: 'pointer',
    color: '#1B1B1B',
    opacity: isPlaying ? 1 : 0.4
  },
  dropdown: {
    zIndex: Z_INDEX_WRAPPER + 2,
    backgroundColor: 'white',
    position: 'absolute',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: 5,
    paddingVertical: 'medium',
    paddingHorizontal: 'xsmall',
    borderColor: '#f6f6f6',
    width: 295,
    opacity: showPopup ? '100%' : '0%',
    display: showPopup ? 'block' : 'none',
    transition: 'all 200ms ease-out',
    top: -20,
    right: -15,
    ['@md']: {
      transform: 'rotate(270deg)',
      top: 20,
      right: -55,
      paddingVertical: 'medium',
      paddingHorizontal: 'xsmall',
      width: 223
    }
  },
  cell: {
    verticalAlign: 'center',
    textAlign: 'left',
    ['@sm']: {
      textAlign: 'center'
    }
  }
});

function VolumePopup({ children, isPlaying, mute }) {
  const [showPopup, setShowPopup] = useState(false);
  const ref = useRef();

  // hide volume control on iOS mobile devices as the volume property is not settable in JavaScript
  const isIOS = navigator.userAgent.indexOf('Mac') !== -1;
  const styles = generateStyles(showPopup, isPlaying, isIOS);

  const Grid = UX2.Component.Grid;
  const Cell = Grid.Cell;

  function handleShowPopup(show) {
    if (isPlaying) {
      setShowPopup(show);
    }
  }

  function handleOutsideClick(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      setShowPopup(false);
    }
  }

  useEffect(() => {
    if (!isPlaying) {
      setShowPopup(false);
    }
  }, [isPlaying]);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <UX2.Element.Block style={ styles.container }>
      <UX2.Element.Icon
        onClick={ () => handleShowPopup(true) }
        icon='volumeUp'
        size='medium'
        style={ styles.icon }
      />
      <div ref={ ref }>
        <UX2.Element.Block style={ styles.dropdown }>
          <Grid gutter={ false } inset={ false } style={ styles.innerContainer }>
            <Cell xs={ 2 } sm={ 3 } style={ styles.cell }>
              { mute }
            </Cell>
            <Cell xs={ 8 } sm={ 6 }>
              { children }
            </Cell>
            <Cell xs={ 2 } sm={ 3 }>
              <UX2.Element.Icon
                onClick={ () => handleShowPopup(false) }
                icon='close'
                size='medium'
                style={ styles.icon }
              />
            </Cell>
          </Grid>
        </UX2.Element.Block>
      </div>
    </UX2.Element.Block>
  );
}

VolumePopup.propTypes = {
  children: PropTypes.node,
  isPlaying: PropTypes.bool,
  mute: PropTypes.func
};

export default VolumePopup;
